module.exports = __webpack_public_path__ + "static/the-library-of-the-unwritten-7bb527b8766f95610c6891b5fc262de9.jpg";